import React, { useEffect, useState } from 'react';
import { Autocomplete, Button, Grid, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getTherapistsByRoleAction } from 'src/redux/actions/getAllTherapistAction';
import loader from 'src/components/LoaderImg/loader.gif';
import {
  addSignerToMdsFormAction,
  resetaddSignerToMdsFormAction,
} from 'src/redux/actions/mdsCommunicationActions';
import { MdsSignType } from 'src/services/apiServices/mdsCommunication/mds-comminication-service';

type Props = {
  close: (action: string) => void;
  mdsFormId: string;
};

function SelectDor(props: Props) {
  const { close, mdsFormId } = props;
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [selectedData, setSelectedData] = useState<any>(null);
  const checkAddDorResponse = useSelector((state: any) => state.addSignerReducer);
  const getTherapistsByRole = useSelector((state: any) => state.getTherapitsByRoleReducer);

  const handleChangeDor = (e: any, value: any) => {
    setSelectedData(value);
  };

  const handleSearchInputChange = (e: any) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeout = setTimeout(() => {
      setSearchData(e.target.value);
    }, 1000);

    setSearchTimeout(timeout);
  };

  const filterOptions = (options: any, state: any) => {
    return options;
  };

  const handleSelectDOR = () => {
    const data: MdsSignType = {
      mdsFormId,
      param: {
        providerId: selectedData?.uuid,
      },
    };
    dispatch(addSignerToMdsFormAction(data));
  };

  useEffect(() => {
    dispatch(getTherapistsByRoleAction('dor'));
  }, []);

  useEffect(() => {
    if (!checkAddDorResponse.isSignerAdded && checkAddDorResponse.response === null) return;
    dispatch(resetaddSignerToMdsFormAction());
    close('');
  }, [checkAddDorResponse]);

  return (
    <Grid sx={{ background: '#FFF', width: '725px' }}>
      <Grid sx={{ padding: '24px' }}>
        <Typography variant="h6">Select a DOR to sign a MDS Assessment</Typography>
      </Grid>

      <Grid sx={{ padding: '24px' }}>
        <Autocomplete
          getOptionLabel={(option: any) => option.name}
          fullWidth
          options={getTherapistsByRole?.response?.data}
          onChange={(e, value) => handleChangeDor(e, value)}
          onInputChange={(e: any) => handleSearchInputChange(e)}
          value={selectedData}
          disabled={
            getTherapistsByRole?.loading || getTherapistsByRole.response?.data?.length === 0
          }
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              fullWidth
              label={
                getTherapistsByRole.response?.data?.length === 0
                  ? 'No Records Found'
                  : `Select DOR Name`
              }
              name="dor"
            />
          )}
        />
      </Grid>
      <Grid
        container
        justifyContent={'right'}
        sx={{ paddingRight: '24px', pb: 3 }}
      >
        <Button
          sx={{ marginRight: '8px' }}
          onClick={() => close('cancal')}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSelectDOR}
          disabled={!selectedData}
        >
          {getTherapistsByRole?.loading || checkAddDorResponse?.loading ? (
            <img
              src={loader}
              style={{ height: 30 }}
            />
          ) : (
            'Confirm'
          )}
        </Button>
      </Grid>
    </Grid>
  );
}

export default SelectDor;
